const setProductCache = (key, value, product) => {
  const cacheValue = localStorage.getItem(product)

  const data = cacheValue ? JSON.parse(cacheValue) : {}

  switch (key) {
    case 'availableFrameSizes':
    case 'availableProductAttributes':
    case 'availableShapes':
    case 'selectedAttributes':
    case 'images':
    case 'frameSize':
    case 'hoveredAttribute':
      value = JSON.stringify(value)
      break
    default:
  }

  data[key] = value

  localStorage.setItem(product, JSON.stringify(data))
}

const setCache = (key, value) => {
  localStorage.setItem(key, value)
}

const getProductCache = (key, product) => {
  const cacheValue = localStorage.getItem(product)

  if (cacheValue === 'null') return null

  if (cacheValue) {
    const data = JSON.parse(cacheValue)

    switch (key) {
      case 'availableFrameSizes':
      case 'availableProductAttributes':
      case 'availableShapes':
      case 'selectedAttributes':
      case 'images':
      case 'frameSize':
      case 'hoveredAttribute':
        return data[key]
          ? JSON.parse(data[key])
          : null
      case 'totalPrice':
        return data[key]
          ? parseFloat(data[key])
          : null
      default:
        return data[key]
    }
  }
}

const getCache = (key) => {
  return localStorage.getItem(key)
}

const useCache = (defaultValue, key, product = null) => {
  if (product) return getProductCache(key, product) || defaultValue

  return getCache(key) || defaultValue
}

const removeCache = (key) => {
  localStorage.removeItem(key)
}

export {
  setProductCache,
  setCache,
  useCache,
  removeCache
}
